import { render, staticRenderFns } from "./PlanningDetails.vue?vue&type=template&id=af9a7ff4&scoped=true&"
import script from "./PlanningDetails.vue?vue&type=script&lang=js&"
export * from "./PlanningDetails.vue?vue&type=script&lang=js&"
import style0 from "./PlanningDetails.vue?vue&type=style&index=0&id=af9a7ff4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9a7ff4",
  null
  
)

export default component.exports